import React, { Component } from "react";
import { Layout, Icon, Col, Tooltip } from "antd";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import { Link } from "react-router-dom";

import LoginPage from "../pages/LoginPage";
import "./MainLayout.css";
import { getUsuario, removeToken, removePermissoes, getTipoUsuario } from "../utils/LoginManager";
import SideMenu from "./SideMenu";
import './SideMenu.css';
import ContentRoutes from './ContentRoutes';
import Colors from '../utils/Colors';
import AjudaForm from '../components/AjudaForm';


const { Header } = Layout;

export default class MainLayout extends Component {
  state = {
    tipoUsuario: '',
    formAjudaVisivel: false,
  };

  componentDidMount() {
    // getTipoUsuario().then(tipoUsuario => {
    //   this.setState({ tipoUsuario });
    // })
  }

  sair = async () => {
    removeToken();
    removePermissoes();
    this.props.history.push("/login");
  };


  renderConteudo = () => {
    const usuario = getUsuario();

    return (
      <Layout className="mainLayout">
        <SideMenu />

        <Layout>
          <Header className="mainLayoutHeader" style={{ background: Colors.primary }}>
            <Col xs={20}>
              <Icon type="home" className="iconeLayout" style={{ color: Colors.dividerLight }} />
              {process.env.NODE_ENV === 'development' ? null : (
                <span style={{ color: Colors.dividerLight, fontSize: 18 }}> {usuario.emp_nome}</span>
              )}
            </Col>

            <Col xs={1} style={{ textAlign: 'right', marginTop: 4, paddingLeft: 20 }}>
              <Tooltip title="Configurações do Sistema">
                <Link to="/configuracoes">
                  <Icon type="setting" />
                </Link>
              </Tooltip>
            </Col>

            <Col xs={1} style={{ textAlign: 'right', marginTop: 4, paddingLeft: 20 }}>
              <Tooltip title="Ajuda (Tutoriais do Sistema)">
                {/* <Link to="/ajuda"> */}
                <Link to="#" onClick={() => this.setState({ formAjudaVisivel: true })}>
                  <Icon type="question-circle-o" />
                </Link>
              </Tooltip>
            </Col>

            <Col xs={1} style={{ textAlign: 'right', marginTop: 4, paddingLeft: 20 }}>
              <Tooltip title="Sobre o Sistema">
                <Link to="/sobre">
                  <Icon type="info-circle-o" />
                </Link>
              </Tooltip>
            </Col>

            <Col xs={1} style={{ textAlign: 'right', marginTop: 4, paddingLeft: 20 }}>
              <a href="" onClick={this.sair}>
                <Tooltip title="Sair" placement="bottomLeft">
                  <Icon type="logout" />
                </Tooltip>
              </a>
            </Col>

            <AjudaForm
              visivel={this.state.formAjudaVisivel}
              onClose={() => this.setState({ formAjudaVisivel: false })}
            />


          </Header>

          <ContentRoutes />
        </Layout>

      </Layout >
    );
  };

  render() {
    return (
      <Switch>
        <Route path="/login" component={LoginPage} />
        <PrivateRoute render={this.renderConteudo} />
        <div>Página Inicial</div>
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js